import { Button, Pagination, Spin } from 'antd'
import React, {useEffect, useRef, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { httpinstance } from '../../axios/api'
import AcceptedQuoteOceanUserDetails from '../../components/Admin/AcceptedQuoteDetails/AcceptedQuoteOceanUserDetails'
import AcceptedQuoteUserDetails from '../../components/Admin/AcceptedQuoteDetails/AcceptedQuoteUserDetails'
// import ContentHead from '../components/Common/ContentHead'
import CustomeHeader from '../../components/Admin/Common/CustomeHeader'
// import FilterSelect from '../components/Common/FilterSelect'
import RowSelectionTable from '../../components/Admin/Common/RowSelectionTable'
import SimpleSelect from '../../components/Admin/Common/SimpleSelect'
// import SimpleTable from '../components/Common/SimpleTable'
import ViewButton from '../../components/Admin/Common/ViewButton'
// import ViewPage from '../components/Queries/ViewPage'
// import UserDetails from '../components/UserManagement/UserDetails'
import UserDetailsAdmin from '../../components/Admin/UserManagement/UserDetailsAdmin'
import { get_param_url } from '../../functions/Utils'
import { updatenotificationdata } from '../../store/Common/CommonSlice'
import { get_kam_list } from '../../store/Admin/KAM/KAMSlice'
import { get_admin_user_list, get_admin_user_list_filter, get_user_list, kam_reassign_user } from '../../store/Admin/UserManagement/UserManagementSlice'
import { CustomeButton, LeftHead, SubHeadContainer, SubHeadTitle } from '../../StyledComponents/Common'
import {  ContentContainer, TableTitle, TableTop } from '../../StyledComponents/CreateKeyAccountManager'
import { MainContainer } from '../../StyledComponents/Dashboard'
import { IconImg } from '../../StyledComponents/Header'
import { FilterSection, LabelItem, RightSection, SpinContainer } from '../../StyledComponents/Queries'
import {organizationlist} from '../../store/Organization/organizationSlice'
import SearchBox from '../../components/Admin/Common/SearchBox'
import { authuser } from '../../store/Authentication/AuthSlice'
import UserListPagination from '../../components/Admin/UserManagement/UserListPagination'
import { formatBranches } from '../../components/Admin/UserManagement/KamUserKycTable'
let debounceTimer= null

function UserManagementAdmin() {
    const loginedUser = useSelector(authuser);
    const userroles = loginedUser?.userroles;
    const dispatch = useDispatch()
    const navigate = useNavigate();
    // const [searchParams] = useSearchParams();
    const [pageType, setPageType] = useState("table");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentTab, setCurrentTab] = useState("1");
    const [pageSize, setPageSize] = useState(10);
    const [instance, setInstance] = useState({});
    const [query_instance, setQueryInstance] = useState({});
    const [selectedUsers, setSelectUser] = useState([])
    const [kam_reassign, setKamReassign] = useState(false)
        const [orgdata,setOrgdata]=useState([])
    
    const [state, setState] = useState({
        filter_value: null,
        reassign_kam: null
    })
   
    const [data, setData] = useState([]);
    const [kam_list, setKamList] = useState([]);
    const [kam_reassign_list, setKamReassignList] = useState([]);
    const [loading, setLoading] = useState(true)
    // Total rows across all pages — the backend's pagination.total when it sends one.
    const [total, setTotal] = useState(0);
    // True when the backend paged the response itself (sent pagination.total);
    // otherwise it returned every row and the table slices client-side.
    const [serverPaged, setServerPaged] = useState(false);
    const [reAssignloading, setReassignLoading] = useState(false)
    // Bump to re-fetch the current page (after a reassign / branch update).
    const [reloadKey, setReloadKey] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [search, setSearch] = useState("");
    const [branchModalOpen, setBranchModalOpen] = useState(false);
    const [branchModalRecord, setBranchModalRecord] = useState(null);
    const [allBranches, setAllBranches] = useState([]);
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [branchDropdownOpen, setBranchDropdownOpen] = useState(false);
    const [branchesLoading, setBranchesLoading] = useState(false);
    const branchDropdownRef = useRef(null);
    //  const[kam_ids, setKamId] = useState(null)
    
//   const userId = searchParams.get('user_id');
//   console.log(userId,"user_id")
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (branchDropdownRef.current && !branchDropdownRef.current.contains(e.target)) {
                setBranchDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };
    useEffect(()=>{
            dispatch(organizationlist("all")).then(res=>{
                // if(res?.payload?.data?.statusCode === 200 ){
                   setOrgdata(res?.payload?.data)
    
                // }
                
            }).catch(err=>{
                console.error(err);
            })
        },[])

    // Paginated user list: admin/list_user?page=&limit=&search=, or
    // admin/users_filter_by_kam with { kam_id, page, limit } when a KAM filter is set.
    useEffect(()=>{
        if(pageType !== 'table') return;
        // Ignore responses from superseded requests (older page/search/filter).
        let stale = false;
        setQueryInstance({})
        setLoading(true)
        const kamId = state.filter_value != null ? kam_list[state.filter_value]?._id : null;
        const pageParams = { page: currentPage, limit: pageSize };
        if (search) pageParams.search = search;
        const request = kamId
            ? get_admin_user_list_filter({ kam_id: kamId, ...pageParams })
            : get_admin_user_list(`?${new URLSearchParams(pageParams).toString()}`);
        dispatch(request)
        .then(res=>{
            if(stale) return;
            if(res?.payload?.data?.statusCode === 200 ){
                const rows = res?.payload?.data?.data || [];
                const serverTotal = res?.payload?.data?.pagination?.total;
                setData(rows)
                setServerPaged(serverTotal != null)
                setTotal(serverTotal ?? rows.length)
            }
        })
        .catch(err=>{
            console.error(err);
        })
        .finally(()=> { if(!stale) setLoading(false) })
        return () => { stale = true }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[pageType, currentPage, pageSize, search, state.filter_value, reloadKey])

    useEffect(()=>{
        if(pageType === 'table'){
            dispatch(get_kam_list(''))
            .then(res=>{
                // console.log('login res => ',res);
                if(res?.payload?.data?.statusCode === 200 ){
                    setKamList(res?.payload?.data?.data)
                    setKamReassignList(res?.payload?.data?.data)
                }
            })
            .catch(err=>{
                console.error(err);
            })
        }
    },[pageType])
// console.log("85",kam_list)
    useEffect(()=>{
        const user_id = get_param_url("user_id")
        console.log(user_id)
        if(user_id && data.length){
            setLoading(true)
            let record = data.filter((i)=> i._id == user_id)[0]
            setLoading(true)
            console.log(data,record,user_id)
            handleView(record)
        }
    },[data])

    useEffect(()=>{
        if(state.filter_value && kam_list.length){
            // let kam_reassign_list = kam_list.filter((i)=> i._id != kam_list[state.filter_value]._id)
            // console.log(state,kam_list)
            let kam_reassign_list = kam_list.filter((i)=> i._id != state.filter_value)
            setKamReassignList(kam_reassign_list)
        }
    },[state.filter_value])

    const handlePageSizeChange = (size) => {
        setPageSize(size);
        setCurrentPage(1);
    };

    const handleView = (record) => {
        // console.log(record,"tfghj")
        setInstance(record)
        let pid=record?._id;
        // let odata=orgdata;
        let buttonvisible=false;
        
        for(let item of orgdata){
            const ud = item.user_details;
            for(let data of ud){
                if(data._id == pid){
                    buttonvisible = true;
                    
                    break;
                }
            }
        }
        setPageType("view_page")
        // buttonvisible===true?:setLoading(true)
    }

    // The list effect re-fetches (via users_filter_by_kam) when filter_value changes.
    const handleFilterChange = (value) => {
        setCurrentPage(1)
        setState((prevState)=> {
            return {
                ...prevState,
                filter_value: value,
                reassign_kam: null
            }
        })
    }
//   console.log("kamid",kam_ids)
    const handleReassignChange = (value)=> {
        setState((prevState)=> {
            return {
                ...prevState,
                reassign_kam:value
            }
        })
    }

    const handleReassignSubmit = (value) => {
        // console.log(state.reassign_kam,"sdfghjk")
        const kamid=kam_list[state.reassign_kam]

        // console.log(kamid,"DFGHJK")
        setReassignLoading(true)
        const param = { 
            kam_id : kamid?._id, //state.reassign_kam
            user_id : selectedUsers,
        }
        // console.log(param)
        dispatch(kam_reassign_user(param))
        .then(res=>{
            // console.log('login res => ',res);
            if(res?.payload?.data?.statusCode === 200 ){
                setReassignLoading(false)
                dispatch(updatenotificationdata(res?.payload?.data))
                const kam_id = get_param_url("kam_id")
                // console.log(kam_id)
                if(kam_id){
                    navigate(`/create-key-account-manager?kam_id=${kam_id}`)
                }else {
                    setReloadKey((k)=> k + 1)
                    setSelectUser([])
                }
            }
        })
        .catch(err=>{
            console.error(err);
        })
    }

    const handleBackArrow = () => {
        setCurrentTab("2")
        setQueryInstance({})
      }

    const openBranchModal = (record) => {
        setBranchModalRecord(record);
        setSelectedBranches([]);
        setBranchDropdownOpen(false);
        setBranchModalOpen(true);
        setBranchesLoading(true);
        const preSelectedIds = (record?.branch_name || [])
            .join(',')
            .match(/\d+/g)
            ?.map(Number) || [];
        const rawIds = localStorage.getItem('allowed_branch_id');
        const cassIds = rawIds?.match(/\d+/g)?.map(Number) || [];
        if(cassIds){
        httpinstance.post('/cass-details', { cass_ids: cassIds })
            .then(res => {
                const branches = res?.data?.data?.data || [];
                setAllBranches(branches);
                if (preSelectedIds.length) {
                    setSelectedBranches(branches.filter(b => preSelectedIds.includes(b.id)));
                }
            })
            .catch(err => console.error(err))
            .finally(() => setBranchesLoading(false));}
    };

    const closeBranchModal = () => {
        setBranchModalOpen(false);
        setBranchModalRecord(null);
        setAllBranches([]);
        setSelectedBranches([]);
    };

    const toggleBranch = (branch) => {
        setSelectedBranches(prev =>
            prev.some(b => b.id === branch.id)
                ? prev.filter(b => b.id !== branch.id)
                : [...prev, branch]
        );
    };

    const removeBranch = (id) => {
        setSelectedBranches(prev => prev.filter(b => b.id !== id));
    };

    const handleBranchSubmit = () => {
        const payload = {
            id: branchModalRecord?._id,
            branch_name: selectedBranches.map(b => String(b.id)),
        };
        console.log('Selected branch IDs:', payload.branch_name);
        httpinstance.patch('/user/branch', payload)
            .then(res => {
                console.log('Branch update response:', res);
                closeBranchModal();
                setReloadKey((k)=> k + 1);
            })
            .catch(err => console.error('Branch update error:', err));
    };

    //   console.log("hiii",state?.filter_value);
   


    const columns = [
        {
            title: 'User ID',
            // dataIndex: 'id',
            dataIndex: 'index',
            render: (text, record, index) => {
                // Calculate the actual index based on current page and page size
                return (currentPage - 1) * pageSize + index + 1;
            },
        },
        {
            title: 'User Full Name',
            dataIndex: 'full_name',
        },
        {
            title: 'Organization Name',
            dataIndex: 'company_name',
        },
        {
            title: 'Key Account Manager',
            dataIndex: 'keyaccount_manager',
            render: (text, record) => (
                <span>{record?.kam_user?.full_name}</span>
              ),
        },
        {
            title: 'Customer Type',
            dataIndex: 'customer_type',
            render: (text) => <span>{text || '—'}</span>,
        },
        {
            title: 'Branch',
            dataIndex: 'branch_name',
            render: (text, record) => <span>{formatBranches(record?.branch_name)}</span>,
        },
        {
            title: 'Platform Name',
            dataIndex: 'platform_name',
            render: (text) => <span>{text || '—'}</span>,
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (text, record) => (
                <div className="flex items-center gap-2 justify-center">
                    <ViewButton handleClick={handleView} data={record} />
                    {/* <button
                        onClick={() => openBranchModal(record)}
                        className="bg-yellow-500 hover:bg-black text-white text-xs font-semibold py-1 px-3 rounded-md transition-colors"
                    >
                        Branch Selection
                    </button> */}
                </div>
              ),
        }
      ];
      
    //   console.log("hi2",state,kam_list,selectedUsers);
    console.log(query_instance,"hi");

    const onSearch = (value)=>{
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            setSearch(value?.trim() || "");
            setCurrentPage(1);
        }, 700);
    }
  return (
    <div className="userManagementAdminMain">
    <MainContainer>
      <CustomeHeader title="User Management" description="View all users in the system and the complete action." />
      {pageType === 'table'? 
      <>
       <div className="mt-4 tableResponsiveASAP">
        <ContentContainer>
            <TableTop>
                <TableTitle>User List</TableTitle>
                <RightSection>
                    {selectedUsers.length ? 
                        <FilterSection>
                            
                            {kam_reassign ? 
                                <SimpleSelect options={kam_reassign_list} width="180px" value={state.reassign_kam} handleChange={handleReassignChange} placeholder="Select KAM to Assign" />
                            : <CustomeButton size='large' onClick={()=> setKamReassign(true)} >KAM Reassign</CustomeButton>}
                            {state.reassign_kam ? 
                                    <CustomeButton size='large' loading={reAssignloading} onClick={()=> handleReassignSubmit()} >Submit</CustomeButton>// loading={reAssignloading}
                            : null}
                        </FilterSection>:
                     null}
                    <FilterSection>
                        <LabelItem>Filter by</LabelItem>
                        <SimpleSelect options={kam_list} width="128px" value={state.filter_value} handleChange={handleFilterChange} placeholder="Select KAM" />
                    </FilterSection>
                    <SearchBox  onSearch={onSearch} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                </RightSection>
            </TableTop>
            {loading? 
                <SpinContainer className='user-quote'>
                    <Spin />
                </SpinContainer>: 
                // <SimpleTable currentPage={currentPage} pageSize={pageSize} columns={columns} data={data} />
                <RowSelectionTable rowKey="_id" serverPaginated={serverPaged} currentPage={currentPage} pageSize={pageSize} columns={columns} data={data} setSelectArchive={setSelectUser} checkedValues={selectedUsers} />
            }
            <UserListPagination
                total={total}
                currentPage={currentPage}
                pageSize={pageSize}
                onPageChange={handlePageChange}
                onPageSizeChange={handlePageSizeChange}
            />
        </ContentContainer>
       </div>
      </>
      
        :pageType === 'view_page'? 
        <>
            {query_instance?.queryId? 
                // <ViewPage setPageType={setPageType} instance={query_instance} parent_type="user_management" setQueryInstance={setQueryInstance} setCurrentTab={setCurrentTab} />
                <ContentContainer>
                    <SubHeadContainer className='flex-column'>
                        <LeftHead>
                            <IconImg onClick={()=> handleBackArrow()} src={require('../../assets/admin/images/back_page_arrow.png')} />
                            <IconImg onClick={()=> handleBackArrow()}  />
                            <SubHeadTitle>Details</SubHeadTitle>
                        </LeftHead>
                    </SubHeadContainer>
                    {userroles === "ocean_admin" ?
                        <AcceptedQuoteOceanUserDetails instance={query_instance} setQueryInstance={setQueryInstance} setPageType={setPageType} />
                    :
                        <AcceptedQuoteUserDetails instance={query_instance} setQueryInstance={setQueryInstance} setPageType={setPageType} />
                    }
                </ContentContainer>
            : 
            <ContentContainer>
                {/* <ContentHead title="User Details"  handleClick={()=> setPageType("table")} /> */}
                <UserDetailsAdmin instance={instance} setInstance={setInstance} setQueryInstance={setQueryInstance} tab={currentTab} setPageType={setPageType} kam_list={kam_list} />
            </ContentContainer> }
            
        </>
       
        
        : null}
      
      
      {branchModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md p-6">
            <h2 className="text-xl font-bold mb-4">Branch Selection</h2>
            <div>
              <label className="block text-sm font-medium text-gray-700">Branches</label>
              <div className="relative mt-1" ref={branchDropdownRef}>
                <div
                  className="min-h-[42px] w-full rounded-md border-2 border-black p-2 flex flex-wrap gap-1 cursor-pointer"
                  onClick={() => setBranchDropdownOpen(o => !o)}
                >
                  {selectedBranches.length === 0 && (
                    <span className="text-gray-400 text-sm">Select branches...</span>
                  )}
                  {selectedBranches.map(b => (
                    <span
                      key={b.id}
                      className="flex items-center gap-1 bg-yellow-100 border border-yellow-400 rounded px-2 py-0.5 text-xs font-medium"
                    >
                      {b.branch_name}
                      <button
                        type="button"
                        className="text-gray-500 hover:text-red-500 leading-none ml-1"
                        onClick={(e) => { e.stopPropagation(); removeBranch(b.id); }}
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
                {branchDropdownOpen && (
                  <div className="absolute z-20 w-full bg-white border border-gray-300 rounded-md shadow-lg max-h-48 overflow-y-auto mt-1">
                    {branchesLoading ? (
                      <div className="p-3 text-sm text-gray-500 text-center">Loading branches...</div>
                    ) : allBranches.length === 0 ? (
                      <div className="p-3 text-sm text-gray-500 text-center">No branches available</div>
                    ) : (
                      allBranches.map(b => (
                        <label
                          key={b.id}
                          className={`flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-50 ${
                            selectedBranches.some(s => s.id === b.id) ? 'bg-blue-50' : ''
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={selectedBranches.some(s => s.id === b.id)}
                            onChange={() => toggleBranch(b)}
                            className="w-4 h-4 accent-yellow-500"
                          />
                          <span className="text-sm">{b.branch_name}</span>
                        </label>
                      ))
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="flex justify-end gap-3 mt-6">
              <button
                type="button"
                onClick={closeBranchModal}
                className="bg-black text-white hover:bg-yellow-500 font-bold py-2 px-4 rounded-md"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleBranchSubmit}
                className="bg-yellow-500 text-white hover:bg-black font-bold py-2 px-4 rounded-md"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </MainContainer>
    </div>
  )
}

export default UserManagementAdmin
